// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3EsqB","options":"style_options__3UHpx","title":"style_title__W5Px_","content":"style_content__29dnW","list":"style_list__3zh4s"};